export default __webpack_public_path__ + "static/okr-outcome-3948204c4c9371421caedbc0ff77e586.webm";